import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { NavigationEnd, Route, Router } from "@angular/router";
import { GroupModulesEnum } from "src/app/core/enum/group-modules.enum";
import { RolesUsersEnum } from "src/app/core/enum/roles-users.enum";
import { LocalStorage } from "src/app/core/helpers/local-storage";
import { TogglesConfiguration } from "../../core/enum/toggles-configuration.enum";
import { TogglesValidation } from "../../core/helpers/toggles";
import { AuthenticationService } from "../../core/services/auth.service";
import { ApiServiceShared } from "../../core/services/shared.service";

import { ToggleMenuService } from "src/app/core/services/toggle-menu.service";

import { Observable } from "rxjs";
import { take, tap } from "rxjs/operators";
import Swal from "sweetalert2";

import { ApiServiceNotifications } from "src/app/core/services/notifications.service";
import { CompaniesService } from "src/app/core/services/companies.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit {
  @Input() showMobileMenu: boolean;

  user = LocalStorage.getItem("currentUser");
  group = LocalStorage.getItem("groupUser");
  selected: string;

  hiddenBadge: boolean = false;
  subscription: any;
  statusShowAllNotifications: boolean = false;
  notificationsList$: Observable<any>;
  numberOfNotifications: number = 0;

  menu = [
    {
      name: "Home",
      img: true,
      alt: "icone da dashboard",
      icon: "fg fg-vuesaxlinearEssetionalhome-2",
      url: "/dashboard",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    {
      name: "Home",
      img: true,
      alt: "icone da dashboard",
      icon: "fg fg-vuesaxlinearEssetionalhome-2",
      icon_business_banker: "fg fg-vuesaxlinearEssetionalhome-2",
      url: "/dashboard-manager",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: ["LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    {
      name: "Consulta Serasa",
      img: true,
      alt: "icone da consulta serasa",
      icon: "fn fn-vuesaxBoldSerasa",
      icon_business_banker: "fn fn-vuesaxBoldSerasa",
      url: "/serasa-extract-list",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      toggleShow: TogglesValidation.toggleShow(TogglesConfiguration.CONSULT_SERASA)
    },
    {
      name: "Consulta Serasa",
      img: true,
      alt: "icone da consulta serasa",
      icon: "fn fn-vuesaxBoldSerasa",
      icon_business_banker: "fn fn-vuesaxBoldSerasa",
      url: "/serasa-consultation",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: ["LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.SERASA,
      toggleShow: TogglesValidation.toggleShow(TogglesConfiguration.CONSULT_SERASA)
    },
    {
      name: "Empresas",
      img: true,
      alt: "icone de Empresas",
      icon: "fg fg-vuesaxboldBuildingbuildings",
      url: "/companies",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.COMPANIES
    },
    {
      name: "Leads",
      img: true,
      icon: "fg fg-vuesaxlinearUsersuser-cirlce-add",
      imgLink: "icon-user-cirlce-add.png",
      url: "/import-leads/admin",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    {
      name: "Leads",
      img: true,
      icon: "fg fg-vuesaxlinearUsersuser-cirlce-add",
      imgLink: "fg-vuesaxlinearuser-cirlce-add",
      url: "/import-leads/corban",
      permission: ["CORBAN", "PARTNER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    {
      name: "Leads",
      img: true,
      icon: "fg fg-vuesaxlinearUsersuser-cirlce-add",
      imgLink: "fg-vuesaxlinearuser-cirlce-add",
      url: "/import-leads/banker",
      permission: ["BUSINESS BANKER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    {
      name: "Usuários e Clientes",
      img: true,
      alt: "icone de Usuarios",
      icon: "fg fg-vuesaxlinearUsersprofile-2user",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      url: "/users/admin",
      module: GroupModulesEnum.USERS
    },
    {
      name: "Usuários & Clientes",
      img: true,
      alt: "icone de Usuarios",
      icon: "fg fg-vuesaxlinearUsersprofile-2user",
      url: "/users/group",
      permission: ["CORBAN", "PARTNER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.USERS
    },
    {
      name: "Clientes",
      img: true,
      alt: "icone de Usuarios",
      icon: "fg fg-vuesaxlinearUsersprofile-2user",
      url: "/users/client-list",
      permission: ["BUSINESS BANKER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    // {
    //   name: "Propostas",
    //   img: true,
    //   alt: 'icone carteira para as propostas',
    //   icon: "../../../assets/menu-items/icons-svg/propostas.svg",
    //   icon_business_banker: '../../../assets/menu-items/icons-svg/propostas.svg',
    //   permission: ["ADMINISTRADOR", "BUSINESS BANKER", "CORBAN", "PARTNER"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   module: GroupModulesEnum.CLIENTS,
    //   url: "/client-form"
    // },
    {
      name: "Acompanhamento <br> de Propostas",
      img: true,
      alt: "icone do acompanhamento das propostas",
      icon: "fg fg-vuesaxlinearBusinesschart-4",
      icon_business_banker: "fg fg-vuesaxlinearBusinesschart-4",
      url: "/kanban-bitrix",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.PROPOSES
    },
    // {
    //   name: "Base de Clientes",
    //   img: true,
    //   alt: 'icone Clientes',
    //   icon: "../../../assets/menu-items/icons-svg/base-de-clientes.svg",
    //   icon_business_banker: '../../../assets/menu-items/icons-svg/base-de-clientes.svg',
    //   url: "/client-list",
    //   permission: ["BUSINESS BANKER", "CORBAN", "PARTNER", "ADMINISTRADOR"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   module: GroupModulesEnum.PROPOSES
    // },
    {
      name: "Teddy+BB Play",
      img: true,
      alt: "icone de Play",
      icon: "fg fg-vuesaxlinearplay-circle-2",
      icon_business_banker: "fg fg-vuesaxlinearplay-circle-2",
      url_externo: this.user.cobanplay_oauth,
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      tooltip: "Materiais de apoio para redes sociais e anúncios",
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.MAIS_DIGITAL_PLAY,
      toggleShow: TogglesValidation.toggleShow(TogglesConfiguration.MAIS_DIGITAL_PLAY)
    },
    {
      name: "Feed de Notícias",
      img: true,
      alt: "icone de Feed de Notícias",
      icon: "fg fg-vuesaxlinearplay-circle",
      icon_business_banker: "fg fg-vuesaxlinearplay-circle",
      url: "/admin-feed",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    // {
    //   name: "Open Finance",
    //   img: true,
    //   alt: 'icone Cateado desbloqueado',
    //   icon: "fg-vuesaxlinearOpenFinance-4",
    //   icon_business_banker: "fg-vuesaxlinearOpenFinance-4",
    //   url: null,
    //   permission: ["ADMINISTRADOR", "BUSINESS BANKER", "CORBAN", "PARTNER"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   tooltip: "Compartilhamento de dados e informações financeiras",
    //   module: GroupModulesEnum.OPEN_FINANCE,
    //   childs: [
    //     {
    //       name: "Solicitar",
    //       img: false,
    //       alt: 'icone de papel com uma seta pra cima',
    //       icon: null,
    //       url: "/client-form/page/open-finance",
    //       permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
    //     },
    //     {
    //       name: "Compartilhados",
    //       img: false,
    //       alt: 'icone de aviãozinho de papel',
    //       icon: null,
    //       url: "/open-finance-list"
    //     },
    //     {
    //       name: "Saiba Mais",
    //       img: false,
    //       alt: 'icone papel com um + no meio',
    //       icon: null,
    //       url: "/open-finance-iframe"
    //     }
    //   ]
    // },
    {
      name: "Editar Banners",
      img: true,
      alt: "icone editar banner",
      icon: "fg fg-vuesaxlineargallery-edit",
      icon_business_banker: "banner-edit.svg",
      url: "/admin-banner",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    // {
    //   name: "Crédito Imobiliário",
    //   img: true,
    //   icon: "credito-imobiliario.svg",
    //   icon_business_banker: "credito-imobiliario-branco.png",
    //   url_externo: "https://simulador-beta.credipronto.com.br/simulator/consultor/?account_id=f88ce471-5a86-11eb-ad85-060528336625&corretor_id=4537e453-2caa-93c0-21d9-60be4caba7fa&lead_source=940",
    //   permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   module: GroupModulesEnum.REAL_ESTATE_CREDIT
    // },
    {
      name: "Minhas Comissões",
      img: true,
      alt: "icone grafico de comições",
      icon: "fg fg-vuesaxlinearMoneyreceipt-text-2",
      icon_business_banker: "fg fg-vuesaxlinearMoneyreceipt-text-2",
      url: "/my-comissions",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      module: GroupModulesEnum.COMMISSION
    },
    // {
    //   name: "Investimentos",
    //   img: true,
    //   alt: 'icone de grafico  de investimentos',
    //   icon: "../../../assets/menu-items/icons-svg/investimentos.svg",
    //   icon_business_banker: "../../../assets/menu-items/icons-svg/investimentos.svg",
    //   label: "Em breve",
    //   url: false,
    //   permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   module: GroupModulesEnum.INVESTMENT
    // },
    {
      name: "Loja Banker",
      img: false,
      alt: "icone usuario da loja",
      icon: "fg fg-vuesaxboldShopshop",
      icon_business_banker: false,
      url: "/admin-store/list",
      permission: ["ADMINISTRADOR"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"]
    },
    /*{
      name: "Academia",
      img: true,
      icon: "academy-branco.png",
      icon_business_banker: "academy-branco.png",
      url: "/academy-360",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: [null, 'LEVEL_1', 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
      tooltip: "Treinamentos dos produtos e parceiros",
      module: GroupModulesEnum.ACADEMY
    },
    {
      name: "Vitrine",
      img: true,
      icon: "vitrine-branco.png",
      icon_business_banker: "vitrine-branco.png",
      url: "/vitrine-360",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: ['LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
      tooltip: "Descrições e regras dos produtos",
      module: GroupModulesEnum.SHOWCASE
    },
    {
      name: "Marketing",
      img: true,
      icon: "marketing-branco.png",
      icon_business_banker: 'marketing-branco.png',
      url: "/marketing",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
      tooltip: "Materiais de apoio para redes sociais e anúncios",
      module: GroupModulesEnum.MARKETING
    },*/
    {
      name: "Formulários",
      img: false,
      alt: "icone do formulario",
      icon: "fg fg-vuesaxlineartask-square",
      icon_business_banker: false,
      url: "/form-list",
      permission: ["ADMINISTRADOR"],
      level: [null]
    },
    {
      name: "Modelos de Emails",
      img: false,
      alt: "icone de envelopes de email",
      icon: "fg fg-vuesaxlinearsms-edit",
      icon_business_banker: false,
      url: "/email-list",
      permission: ["ADMINISTRADOR"],
      level: [null]
    },
    {
      name: "Comunicador",
      img: false,
      alt: "icone circulo de seta",
      icon: "fg fg-vuesaxlinearArrowrefresh-2",
      icon_business_banker: false,
      url: "/comunicador-list",
      permission: ["ADMINISTRADOR"],
      level: [null]
    },
    {
      name: "FAQ",
      img: false,
      alt: "icone circulo de seta",
      icon: "fn fn-vuesaxlinearEssetionalHelper",
      icon_business_banker: false,
      url: "faq-adm/list",
      permission: ["ADMINISTRADOR"],
      level: [null],
      tooltip: "Ajuda",
      toggleShow: TogglesValidation.toggleShow(TogglesConfiguration.FAQ_ADMIN)
    },
    {
      name: "FAQ",
      img: false,
      alt: "icone circulo com uma interrogação",
      icon: "fn fn-vuesaxlinearEssetionalHelper",
      url: "faq",
      permission: ["BUSINESS BANKER", "CORBAN", "PARTNER"],
      level: [null, "LEVEL_1", "LEVEL_2", "LEVEL_3"],
      tooltip: "Ajuda",
      toggleShow: TogglesValidation.toggleShow(TogglesConfiguration.FAQ_MANAGER)
    },
    {
      name: "Produtos",
      img: false,
      alt: "icone de carrinho",
      icon: "fg fg-vuesaxlinearshopping-cart",
      icon_business_banker: false,
      url: null,
      permission: ["ADMINISTRADOR"],
      level: [null],
      childs: [
        {
          name: "Grupo",
          img: false,
          icon: null,
          url: "/product-group"
        },
        {
          name: "Produto",
          img: false,
          icon: null,
          url: "/product-list"
        }
      ]
    },
    // {
    //   name: "Comissão",
    //   icon: "fas fa-dollar-sign",
    //   url: "/commission-table",
    //   permission: ["ADMINISTRADOR"],
    // },
    {
      name: "Auditoria",
      img: true,
      alt: "icone de auditoria",
      icon: "fg fg-vuesaxlinearclipboard-text",
      url: "/audit-list",
      permission: ["ADMINISTRADOR"],
      level: [null]
    }
    // {
    //   name: "Termos e Condições",
    //   img: true,
    //   icon: "fg-vuesaxlinearshield",
    //   icon_business_banker: "fg-vuesaxlinearshield",
    //   url: "/terms-conditions",
    //   permission: ["ADMINISTRADOR", "BUSINESS BANKER", "CORBAN", "PARTNER"],
    //   level: [null, 'LEVEL_1', 'LEVEL_2', 'LEVEL_3'],
    //   module: GroupModulesEnum.TERMS_AND_CONDITIONS
    // }
  ];
  result: any;
  img: any;

  constructor(
    public router: Router,
    private companiesService: CompaniesService,
    private authService: AuthenticationService,
    private apiServiceShared: ApiServiceShared,
    private toggleMenuService: ToggleMenuService,
    private apiServiceNotifications: ApiServiceNotifications
  ) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
        this.autoToggleMenu();
      }
    });
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.apiServiceShared
      .updateLocalStorage()
      .pipe(take(1))
      .subscribe(status => {});

    this.getNotifications();
    this.getLogo();
  }
  getLogo() {
    let id = localStorage.getItem("id");
    const response = this.companiesService.getCompanieById(id).subscribe(res => {
      this.result = res;
      let t = JSON.parse(this.result.white_label);
      let y = JSON.parse(t);
      this.img = JSON.parse(y.logo);
    });
  }

  redirectHome() {
    if (this.roles === "ADMINISTRADOR") {
      return this.router.navigate(["/dashboard"]);
    } else {
      return this.router.navigate(["/dashboard-manager"]);
    }
  }

  onToggleMobileMenu() {
    this.toggleMenuService.toggle();
  }

  private autoToggleMenu() {
    this.toggleMenuService.autoToggleMenu();
    this.toggleMenuService.showMobileMenu$
      .pipe(
        tap(isActive => {
          this.showMobileMenu = isActive;
        })
      )
      .subscribe();
  }

  get nameCircle() {
    if (!this.user) {
      return;
    }
    if (this.user.name.split(" ").length === 1) {
      return this.user.name.split(" ")[0].substring(0, 1).toUpperCase();
    }
    if (this.user.name.split(" ").length >= 2) {
      return (
        this.user.name.split(" ")[0].substring(0, 1).toUpperCase() +
        this.user.name.split(" ")[1].substring(0, 1).toUpperCase()
      );
    }
  }

  get roles() {
    return this.user.roles;
  }

  get nameRole() {
    return this.user.roles.toLowerCase();
  }

  get nameUser() {
    return this.user.name;
  }

  viewToggle(item: any) {
    let hasToggleShow: boolean = true;
    if (item.hasOwnProperty("toggleShow")) {
      hasToggleShow = item.toggleShow;
    }
    return hasToggleShow;
  }

  ngAfterViewInit() {
    this.activateMenu();
    this.dropMenuDark();
  }

  removeActiveEl() {
    this.menuAction("show-child-menu", "hidde-child-menu");
    this.menuAction("menu-arrow-open", "menu-arrow-close");
  }

  menuAction(open: string, close: string): void {
    const elements = document.querySelectorAll(`.${open}`);
    elements.forEach(element => {
      element.classList.remove(open);
      element.classList.add(close);
    });
  }

  /**
   * Logout the user
   */
  logout() {
    // location.reload();
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  openCloseMenu(item: any, transition: boolean) {
    this.removeActiveEl();
    const time = transition ? 100 : 0;
    this.selected = item.name;

    setTimeout(() => {
      item.show = !item.show;
    }, time);
  }

  /**
   * On menu click
   */
  onMenuClick(event: any) {
    const nextEl = event.target.nextSibling;
    if (nextEl && !nextEl.classList.contains("open")) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("open");
      }

      nextEl.classList.add("open");
    } else if (nextEl) {
      nextEl.classList.remove("open");
    }
    return false;
  }

  /**
   * Dark Menubar
   */
  darkTopBar() {
    document.body.classList.add("topbar-dark");
    document.body.classList.remove("topbar-light");
    document.body.classList.remove("unsticky-header");
    document.body.classList.remove("boxed-layout");
    document.body.classList.remove("drop-menu-dark");
    document.body.classList.remove("menubar-light");
    document.body.classList.remove("center-menu");
  }

  dropMenuDark() {
    document.body.classList.add("drop-menu-dark");
    document.body.classList.remove("gradient-topbar");
    document.body.classList.remove("boxed-layout");
    document.body.classList.remove("center-menu");
    document.body.classList.remove("menubar-light");
  }

  viewComponent(item) {
    if (this.user.roles === RolesUsersEnum.ADMIN) {
      return item.permission.includes(this.user.roles);
    }

    let hasPermission = true;
    let hasLevel = true;
    let hasModule = true;

    if (item.permission) {
      hasPermission = item.permission.includes(this.user.roles);
    }

    if (item.level) {
      hasLevel = item.level.includes(this.user.permissions_group);
    }

    if (item.module) {
      if (!this.user.modules) {
        return false;
      }

      hasModule = this.user.modules.includes(item.module);
    }

    return hasPermission && hasLevel && hasModule;
  }

  /**
   * Activates the menu
   */

  private activateMenu() {
    const resetParents = (el: Element) => {
      const parent = el.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.remove("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("in");
        }
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.remove("active");
          const childAnchor = parent3.querySelector(".has-dropdown");
          if (childAnchor) {
            childAnchor.classList.remove("active");
          }
        }

        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.remove("in");
        }
        const parent5 = parent4.parentElement;
        if (parent5) {
          parent5.classList.remove("active");
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName("side-nav-link-ref");
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset the parents
      resetParents(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal

      if (location.hash.split("#")[1] === links[i]["href"].split("#")[1]) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("in");
        }
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active");
          const childAnchor = parent3.querySelector(".has-dropdown");
          if (childAnchor) {
            childAnchor.classList.add("active");
          }
        }

        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("in");
        }
        const parent5 = parent4.parentElement;
        if (parent5) {
          parent5.classList.add("active");
        }
      }
    }
  }

  alert(title: string, icon: any) {
    Swal.fire({
      type: icon,
      title,
      showConfirmButton: false,
      timer: 1500
    });
  }

  getNotifications() {
    this.notificationsList$ = this.apiServiceNotifications.getAllNotifications().pipe(
      tap(res => {
        let quantityItemsIsRead: any = 0;

        quantityItemsIsRead = res.Items.filter(item => {
          return item.is_read === 0;
        });

        this.numberOfNotifications = quantityItemsIsRead.length;

        this.numberOfNotifications = this.numberOfNotifications < 99 ? this.numberOfNotifications : 99;
        this.hiddenBadge = this.numberOfNotifications <= 0;
      })
    );
  }

  showAllNotificationsFalse() {
    this.statusShowAllNotifications = false;
  }

  toggleBadgeVisibility() {
    this.hiddenBadge = true;
  }
}
